import { DMSDefaultValuesViewModel, DMSNameDetails, TableNameDetails } from "../business-entities/dms-defaultvalues-view-model";
import { GenericResponse } from "../business-entities/generic-response";
import { DMSDefaultValuesDataService } from "../data-services/dms-defaultvalues-data.service";
import { Injectable } from "@angular/core";
@Injectable({
    providedIn: 'root'
})
export class DMSDefaultValuesService {
    DMSValueId;
    DMSValueModel:DMSDefaultValuesViewModel;
    DMSDefaultList: DMSDefaultValuesViewModel[];
    DMSNameList: DMSNameDetails[];
    TableNameList: TableNameDetails[];
    constructor(private service: DMSDefaultValuesDataService) {
    }

     async getDMSDefaultValues(model: any):Promise<any> {
         await this.service
            .getDMSDefaultValues(model)
            .then(
                (res: GenericResponse<Array<DMSDefaultValuesViewModel>>) => {
                    this.DMSDefaultList = res.responseObject;
                }
            );

        return this.DMSDefaultList;
    }
    async GetDMSName():Promise<any> {
        await this.service
           .GetDMSName()
           .then(
               (res: GenericResponse<Array<DMSNameDetails>>) => {
                   this.DMSNameList = res.responseObject;
               }
           );

       return this.DMSNameList;
   }

    async GetTableName():Promise<any> {
        let tableNameDetails: Array<TableNameDetails>=[];
        await this.service
            .GetTableName()
            .then(
            (res: GenericResponse<Array<TableNameDetails>>) => {
                tableNameDetails = res.responseObject;
            }
        );

        return tableNameDetails;
    }
    AddDMSDefaultValues(model: DMSDefaultValuesViewModel): Promise<GenericResponse<any>> {
        return this.service.AddDMSDefaultValues(model);
    }
    UpdateDMSDefaultValues(Model: DMSDefaultValuesViewModel): Promise<GenericResponse<any>> {
        return this.service.UpdateDMSDefaultValues(Model);
    }
    DeleteDefaultDMSValues(RowId: number):Promise<any> {
        return this.service.DeleteDefaultDMSValues(RowId);
    }
}
